<template>
  <v-app class="unsigned">
    <v-main>
      <v-container fluid class="fill-height pa-0">
        <slot />
      </v-container>
    </v-main>

    <snackbar-alert />
  </v-app>
</template>

<script setup lang="ts"></script>
